// ==================================== COMPONENTS =========================================
// THIRD PARTY/ CORE COMPONENTS
import React, { useState } from 'react';
import { Table } from 'antd';
import FeatherIcon from 'feather-icons-react';
import moment from 'moment';

// USER COMPONENTS
import { UserTableStyleWrapper } from '../../pages/style';
import { TableWrapper } from '../../styled';
import Heading from '../../../components/heading/heading';
import { Button } from '../../../components/buttons/buttons';
import { Cards } from '../../../components/cards/frame/cards-frame';
import EditReferral from './EditReferral';
import DeleteReferral from './DeleteReferral';
import Truncate from '../../../components/utilities/truncate';

const PageTable = ({ referrals, handleDelete, handleEdit, totalReferrals, queryState, currentPage, pageLimit }) => {
  const [state, setState] = useState({
    editModalVisible: false,
    deleteModelVisible: false,
  })

  const [referral, setReferral] = useState({});

  const showModal = (id, type) => {
    setReferral(referrals.find(r => r._id === id));
    if (type === 'edit') setState({ ...state, editModalVisible: true });
    else setState({ ...state, deleteModelVisible: true });
  };

  const onCancel = () => {
    setReferral({});
    setState({ ...state, editModalVisible: false, deleteModelVisible: false, });
  };

  // To handle the page and limit change
  const handlePageOrLimitChange = (data) => { queryState({ ...state, currentPage: data.current, pageLimit: data.pageSize }) };

  const newReferrals = [];

  referrals?.map((r, index) => {
    const { _id, fullName, phoneNumber, message, status, remarks, createdAt } = r;

    return newReferrals.push({
      key: _id,
      sNo: (
        <figure>
          <p>{index + 1}</p>
        </figure>
      ),
      fullName: (
        <div className="user-info">
          <Heading className="user-name" as="h6">
            {fullName}
          </Heading>
        </div>
      ),
      phoneNumber: (
        <div className="user-info">
          <Heading className="user-name" as="h6">
            {phoneNumber?.code}{phoneNumber.number}
          </Heading>
        </div>
      ),
      message: (
        <div className="user-info">
          <Heading className="user-name" as="h6">
            <Truncate ln={55} text={message} />
          </Heading>
        </div>
      ),
      status: (
        <div className="user-info">
          <Heading className="user-name" as="h6">
            {status}
          </Heading>
        </div>
      ),
      remarks: (
        <div className="user-info">
          <Heading className="user-name" as="h6">
            <Truncate ln={55} text={remarks} />
          </Heading>
        </div>
      ),
      createdAt: (
        <div className="user-info">
          <Heading className="user-name" as="h6">
            {moment(createdAt).format('YYYY-MM-DD, h:mm:ss a')}
          </Heading>
        </div>
      ),
      action: (
        <div className="table-actions">
          <Button className="btn-icon" type="info" to="#" shape="circle" onClick={() => showModal(_id, 'edit')}>
            <FeatherIcon icon="edit" size={16} />
          </Button>
          <Button className="btn-icon" type="danger" to="#" shape="circle" onClick={() => showModal(_id, 'delete')}>
            <FeatherIcon icon="trash-2" size={16} />
          </Button>
        </div>
      ),
    });
  });

  const referralTableColumns = [
    {
      title: 'S.No',
      dataIndex: 'sNo',
      key: 'sNo',
    },
    {
      title: 'Full Name',
      dataIndex: 'fullName',
      key: 'fullName',
    },
    {
      title: 'Phone Number',
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
    },
    {
      title: 'Message',
      dataIndex: 'message',
      key: 'message',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: 'Remarks',
      dataIndex: 'remarks',
      key: 'remarks',
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
    },
    {
      title: 'Actions',
      dataIndex: 'action',
      key: 'action',
      width: '90px',
    },
  ];

  return (
    <Cards headless>
      <UserTableStyleWrapper>
        <TableWrapper className="table-responsive">
          <Table
            dataSource={newReferrals}
            columns={referralTableColumns}
            pagination={{
              defaultPageSize: pageLimit,
              total: totalReferrals,
              current: currentPage,
              showSizeChanger: true,
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${totalReferrals} items`,
            }}
            onChange={handlePageOrLimitChange}
          />
        </TableWrapper>
      </UserTableStyleWrapper>
      <EditReferral onCancel={onCancel} visible={state.editModalVisible} referral={referral} handleEdit={handleEdit} />
      <DeleteReferral onCancel={onCancel} visible={state.deleteModelVisible} referral={referral} handleDelete={handleDelete} />
    </Cards>
  );
};

export default PageTable;